import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UW2 {
  doneScreening: "YES" | "NO" | null;
  result: null | "NORMAL" | "ABNORMAL" | "AWAITING";
  abnormalResult: "YES" | "NO" | null;
}

interface UW1 {
  isMedication: "YES" | "NO" | null;
  isBenignGrowths: "YES" | "NO" | null;
  isTreatment: "YES" | "NO" | null;
  isRecurrence: "YES" | "NO" | null;
  isBreastGrowths: "YES" | "NO" | null;
  isColonPolyps: "YES" | "NO" | null;
  isOtherBenignGrowths: "YES" | "NO" | null;
  otherBenignGrowths: string | null;
}

interface Step3State {
  underWriting1: UW1;
  underWriting2: UW2;
  underWriting3: {
    hasSymptomsinSixMonths: null | "YES" | "NO";
  };
}

const initialState: Step3State = {
  underWriting1: {
    isMedication: "NO",
    isBenignGrowths: "NO",
    isTreatment: "NO",
    isRecurrence: "NO",
    isBreastGrowths: "NO",
    isColonPolyps: "NO",
    isOtherBenignGrowths: "NO",
    otherBenignGrowths: "",
  },
  underWriting2: {
    abnormalResult: null,
    doneScreening: null,
    result: null,
  },
  underWriting3: {
    hasSymptomsinSixMonths: null,
  },
};

const step3Slice = createSlice({
  name: "CancerCover-Step3",
  initialState,
  reducers: {
    updateUnderWriting1: (state, action: PayloadAction<Partial<UW1>>) => {
      state.underWriting1 = { ...state.underWriting1, ...action.payload };
    },
    updateUnderWriting2: (state, action: PayloadAction<Partial<UW2>>) => {
      state.underWriting2 = { ...state.underWriting2, ...action.payload };
    },
    updateUnderWtiting3: (
      state,
      action: PayloadAction<Partial<"YES" | "NO">>
    ) => {
      state.underWriting3.hasSymptomsinSixMonths = action.payload;
    },
    updateToIntialState3: (state, action: PayloadAction<any>) => ({
      ...initialState,
    }),
  },
  extraReducers: {},
});

export const {
  updateUnderWriting1,
  updateUnderWriting2,
  updateToIntialState3,
  updateUnderWtiting3,
} = step3Slice.actions;

export default step3Slice.reducer;
